module.exports = __webpack_public_path__ + "static/media/global_user_management.dbde6db3.svg";